document.addEventListener('DOMContentLoaded', (e) => {
	const header = document.querySelector('header.ak-header');
	const body = document.querySelector('body');

	document.addEventListener('click', eventHandler);

	window.addEventListener('scroll', scroll);
	window.addEventListener('resize', scroll);
	scroll();
	
	if(body && body.classList.contains('ak-template-')){
		const h1 = body.querySelector('.ak-section .content > h1');
		if(h1){
			let text = h1.textContent.split(' ');
			text[text.length-1] = `<span class="color-green">${text[text.length-1]}</span>`;
			h1.innerHTML = text.join(' ');
		}
	}
	
	function scroll(){
		const top  = window.pageYOffset || document.documentElement.scrollTop;
		const pct = Math.min(1, top/100);
		console.log(pct);
		header.style.backgroundColor = `rgba(0,0,0,${pct})`;
		header.style.height = `${4.4 - (1 * pct)}rem`;
		header.style.boxShadow = `0 0 ${6 * pct}px #000`;
	}
	
	function eventHandler(e){
		if(e.type == 'click' && e.target.matches('[data-action="open-subscibe-modal"]')){
			document.querySelector('#ak-modal-overlay').classList.add('show');
			document.body.classList.add('ak-modal-open');
			return;
		}
		
		if(e.type == 'click' && e.target.matches('header.ak-header .toggle')){
			header.classList.toggle('open');
			document.body.classList.toggle('ak-nav-open');
			return;
		}
	}
});

function trace(c){if(typeof(console)!=='undefined'){console.log(c);}}

//input-number
customElements.define('ak-input-number', class extends HTMLElement{
	#input;

	init(){
		const component = this;
		
		component.#input = component.querySelector('input');
		
		const plus = document.createElement('button');
		plus.classList.add('plus');
		plus.innerText = '+';
		component.appendChild(plus);

		const minus = document.createElement('button');
		minus.classList.add('minus');
		minus.innerText = '-';
		component.insertBefore(minus, component.#input);

		component.addEventListener('click', component);
		
		trace('TEST')
	}

	connectedCallback(){
		const component = this;
		
		if(document.readyState !== 'loading'){
			component.init();
			return;
		}
		document.addEventListener('DOMContentLoaded', () => component.init());
	}

	handleEvent(e){
		const component = this;

		if(e.target.matches('.plus')){
			e.preventDefault();
			component.#input.value = parseInt(component.#input.value) + 1;
			return;
		}
		if(e.target.matches('.minus')){
			e.preventDefault();
			component.#input.value = Math.max(parseInt(component.#input.value) - 1, 1);
			return;
		}
	}
});

//marquee
customElements.define('ak-marquee', class extends HTMLElement{
	init(){
		const component = this;
		const items = component.querySelectorAll('.item');
		
		const timeline = gsap.timeline({repeat:-1})
		.to(items, {duration:10.0, x:'-100%', ease:'none'});
	}

	connectedCallback(){
		const component = this;
		
		if(document.readyState !== 'loading'){
			component.init();
			return;
		}
		document.addEventListener('DOMContentLoaded', () => component.init());
	}
});

//ak-product-slides
customElements.define('ak-product-slides', class extends HTMLElement{
	#slides;
	#dots = [];
	#active = 0;

	init(){
		const component = this;
		
		const slides = component.#slides = component.querySelectorAll('.slide');
		const dots = component.querySelector('.dots');
		
		slides.forEach(function(element, index, array){
			element.addEventListener('load', component);
			element.classList.toggle('active', index == 0);
			if(dots){
				const dot = document.createElement('button');
				dot.classList.add('dot');
				dot.classList.toggle('active', index == 0);
				dots.appendChild(dot);
				component.#dots.push(dot);
			}
		});

		component.addEventListener('click', component);
		window.addEventListener('resize', component);
		document.addEventListener('keydown', component);

		component.resize();
	}

	connectedCallback(){
		const component = this;
		
		if(document.readyState !== 'loading'){
			component.init();
			return;
		}
		document.addEventListener('DOMContentLoaded', () => component.init());
	}
	
	handleEvent(e){
		const component = this;
		
		if(e.type == 'load'){
			component.resize();
			return;
		}

		if(e.type == 'resize'){
			component.resize();
			return;
		}
		
		if(e.type == 'keydown' && component.classList.contains('overlay')){
			if(e.key == 'Escape'){
				component.toggleOverlay(false);
				return;
			}
			if(e.key == 'ArrowRight'){
				component.next();
				return;
			}
			if(e.key == 'ArrowLeft'){
				component.prev();
				return;
			}
		}

		if(e.type == 'click' && e.target.matches('.slide')){
			component.toggleOverlay(true);
			e.preventDefault();
			return;
		}

		if(e.type == 'click' && e.target.matches('.close')){
			component.toggleOverlay(false);
			e.preventDefault();
			return;
		}

		if(e.type == 'click' && e.target.matches('.dot')){
			const index = Array.from(e.target.parentNode.children).indexOf(e.target);
			component.#active = index;
			component.update();
			e.preventDefault();
			return;
		}

		if(e.type == 'click' && e.target.matches('.prev')){
			component.prev();
			e.preventDefault();
			return;
		}

		if(e.type == 'click' && e.target.matches('.next')){
			component.next();
			e.preventDefault();
			return;
		}
	}
	
	toggleOverlay(show=false){
		const component = this;

		component.classList.toggle('overlay', show);
		component.resize();
	}
	
	prev(){
		const component = this;

		component.#active--;
		if(component.#active < 0){
			component.#active = component.#slides.length-1;
		}
		
		component.update();
	}

	next(){
		const component = this;

		component.#active++;
		if(component.#active > component.#slides.length-1){
			component.#active = 0;
		}

		component.update();
	}
	
	update(){
		const component = this;
		
		component.#slides.forEach(function(element, index, array){
			element.classList.toggle('active', index == component.#active);
		});

		component.#dots.forEach(function(element, index, array){
			element.classList.toggle('active', index == component.#active);
		});
	}
	
	resize(){
		const component = this;
		
		if(component.classList.contains('overlay')){
			component.#slides[0].parentNode.style.height = ``;
			return;
		}
		
		let h = 0;
		component.#slides.forEach(function(element, index, array){
			const img = element.querySelector('img');
			if(img){
				const r = img.getBoundingClientRect();
				h = Math.max(r.height, h);
			}
		});

		component.#slides[0].parentNode.style.height = `${h}px`;
	}
});

//share
customElements.define('ak-share', class extends HTMLElement{
	#input;

	init(){
		const component = this;
		
		component.#input = component.querySelector('input');
		component.#input.value = window.location.href;
		
		component.addEventListener('click', component);
		window.addEventListener('click', component);
	}

	connectedCallback(){
		const component = this;
		
		if(document.readyState !== 'loading'){
			component.init();
			return;
		}
		document.addEventListener('DOMContentLoaded', () => component.init());
	}
	
	handleEvent(e){
		const component = this;
		
		if(e.target.matches('.share')){
			e.preventDefault();
			component.classList.add('open');
			return;
		}
		if(e.target.matches('.copy')){
			e.preventDefault();
			navigator.clipboard.writeText(component.#input.value).then(res=>{
				//console.log('SVG data copied to clipboard.');
				component.classList.add('copied');
				component.#input.value = 'Link copied to clipboard';
			});
			return;
		}
		if(e.target.matches('.close')){
			e.preventDefault();
			component.reset();
			return;
		}
		if(e.target != component){
			component.reset();
			return;
		}
	}
	
	reset(){
		const component = this;
		component.#input.value = window.location.href;
		component.classList.remove('open');
		component.classList.remove('copied');
	}
});

//slideshow:
customElements.define('ak-slideshow', class extends HTMLElement{
	slides; track;
	current = 0;
	start_x;
	moving = false;

	constructor(){
		super();
	}
	
	connectedCallback(){
		const component = this;

		component.slides = component.querySelectorAll('.slide');
		component.track = component.querySelector('.track');

		component.addEventListener('touchstart', component);
		component.addEventListener('touchmove', component);
		component.addEventListener('click', component);
	}

	handleEvent(e){
		const component = this;

		if(e.type == 'touchstart' && (e.target.matches('.track') || e.target.closest('.track'))){
			if(e.touches.length == 1){
				component.start_x = e.touches[0].pageX;
				component.moving = true;
			}
		}

		if(e.type == 'touchmove'){
			if(component.moving){
				let x = e.touches[0].pageX;
				let dx = component.start_x - x;
				if(Math.abs(dx) >= 20){
					if(dx > 0){
						component.next();
					} else {
						component.prev();
					}
					component.moving = false;
				}
			}
		}

		if(e.type == 'click' && e.target.matches('.next')){
			component.next();
		}
		if(e.type == 'click' && e.target.matches('.prev')){
			component.prev();
		}
	}

	next(){
		const component = this;
		
		component.#move('next');
	}
	prev(){
		const component = this;
		
		component.#move('prev');
	}
	#move(direction){
		const component = this;
		
		if(gsap.isTweening(component.slides[0])){
			return;
		}
		
		if(direction == 'next'){
			gsap.to(component.slides, {duration:0.5, x:'-=100%', ease:'power2.inOut', onComplete:function(){
				component.track.appendChild(component.slides[0]);
				gsap.set(component.slides, {x:'0%'});
				component.slides = component.querySelectorAll('.slide');
			}});
		}else{
			component.track.insertBefore(component.slides[component.slides.length-1], component.slides[0]);
			gsap.set(component.slides, {x:'-100%'});
			gsap.to(component.slides, {duration:0.5, x:'0%', ease:'power2.inOut', onComplete:function(){
				component.slides = component.querySelectorAll('.slide');
			}});
		}
	}
});

//subscribe modal:
customElements.define('ak-subscribe-modal', class extends HTMLElement{
	connectedCallback(){
		const component = this;

		component.addEventListener('click', component);
	}

	handleEvent(e){
		const component = this;

		if(e.type == 'click' && e.target.matches('.close')){
			e.preventDefault();
			document.querySelector('#ak-modal-overlay').classList.remove('show');
			document.body.classList.remove('ak-modal-open');
		}
	}
});
